import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useSendDeleteMessage() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  return (messageDeliveryToken) => sendJsonMessage({
    action: 'delete_message',
    body: {
      delivery_token: messageDeliveryToken,
    },
  });
}
